// @core/api/endpoints/attachment/get_upload_url.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetUploadUrlRequest,
  GetUploadUrlResponse,
} from '../../../types/attachment';

const BASE_PATH = '/attachment';

/**
 * Get presigned URL for file upload
 * Generates a presigned URL for direct file upload to cloud storage. Client should upload the file directly to this URL with the specified headers, then call ConfirmUpload.
 */
export async function GetUploadUrl(
  data: GetUploadUrlRequest,
  options?: RequestOptions
): Promise<GetUploadUrlResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/attachments/upload-url`;
  const requestOptions = options;
  return client.post<GetUploadUrlResponse>(requestPath, data, requestOptions);
}
